// extracted by mini-css-extract-plugin
module.exports = {"container":"Cards_container__3UBcE","card":"Cards_card__3y_yE","infected":"Cards_infected__41WDo","recovered":"Cards_recovered__2tvSA","deaths":"Cards_deaths__uaif6"};